import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import ja from "../locales/ja.json";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: "en",
    // translations are bundled so that init is synchronous (no Suspense flash)
    resources: {
      en: { translation: en },
      ja: { translation: ja },
    },
    interpolation: {
      // react already safes from xss
      escapeValue: false,
    },
  });

export default i18n;
